import * as v from 'valibot';
import { MaterialSchema } from '@fe-learner-common';

const ComponentType = v.union([
  v.literal('material-genericfile'),
  v.literal('material-scorequiz'),
  v.literal('material-quiz'),
  v.literal('material-questionnaire'),
  v.literal('material-flashcard'),
  v.literal('material-scorm'),
  v.literal('material-htmlsnippet'),
  v.literal('material-challenge'),
  v.literal('material-external'),
  v.literal('material-crisp'),
  v.literal('material-linkedsubproject'),
  v.literal('material-audioplayer'),
  v.literal('material-website'),
  // video types
  v.literal('material-oembedvideo'),
  v.literal('material-poembedvideo'),
  v.literal('material-wevideo'),
  v.literal('material-youtubevideo'),
  v.literal('material-diplomavideo'),
  v.literal('material-vimeovideo'),
  v.literal('material-vimeo2video'),
  v.literal('material-brightcovevideo'),
  // image types
  v.literal('material-image'),
  v.literal('material-unsplashimage'),
]);

const FilterType = v.union([
  v.literal('video'),
  v.literal('image'),
  v.literal('audioplayer'),
  v.literal('genericfile'),
  v.literal('other'),
]);

export const ResourceSchema = v.object({
  material: MaterialSchema,
  tags: v.array(v.string()),
  created: v.number(),
  constraintType: v.nullable(v.string()),
  constraint: v.nullable(v.string()),
  materialId: v.string(),
  rid: v.string(),
  newResource: v.boolean(),
  filterType: FilterType,
  usable: v.boolean(),
  useMode: v.nullable(v.string()),
  componentType: ComponentType,
  link: v.nullish(v.string()),
});

export const ResourcesSchema = v.object({
  resources: v.array(ResourceSchema),
});

export type TResourceType = v.Output<typeof ComponentType>;
export type TResourceData = v.Output<typeof ResourceSchema>;
export type TResourcesData = TResourceData[];

export const RESOURCE_GROUP_TYPES = [
  'video',
  'image',
  'audio',
  'document',
  'link',
  'other',
] as const;
type TResourceGroupTypeTuple = typeof RESOURCE_GROUP_TYPES;
export type TResourceGroupType = TResourceGroupTypeTuple[number];

export const resourceTypeToGroup = (
  type: TResourceType,
): TResourceGroupType => {
  switch (type) {
    case 'material-oembedvideo':
    case 'material-poembedvideo':
    case 'material-wevideo':
    case 'material-youtubevideo':
    case 'material-diplomavideo':
    case 'material-vimeovideo':
    case 'material-vimeo2video':
    case 'material-brightcovevideo':
      return 'video';
    case 'material-audioplayer':
      return 'audio';
    case 'material-image':
    case 'material-unsplashimage':
      return 'image';
    case 'material-website':
      return 'link';
    case 'material-genericfile':
      return 'document';

    default:
      return 'other';
  }
};
